<template>
  <main class="terms" v-html="renderedHtml"></main>
  <AppFooter />
</template>

<script>
import { marked } from "marked";
import AppFooter from "../components/AppFooter.vue";
import termsFr from "../i18n/legal/terms.fr.md";
import termsEn from "../i18n/legal/terms.en.md";
import termsDe from "../i18n/legal/terms.de.md";

const SOURCES = { fr: termsFr, en: termsEn, de: termsDe };

export default {
  name: "TermsOfUse",
  components: {
    AppFooter,
  },
  computed: {
    renderedHtml() {
      const locale = this.$i18n.locale;
      const md = SOURCES[locale] || SOURCES.en;
      return marked.parse(md);
    },
  },
};
</script>

<!-- Layout + typography styles live in src/styles/legal-pages.css (imported globally
     in main.js) because the content is rendered via v-html (marked) and Vue scoped
     CSS does not reach those nodes. -->
